import { useMutation } from '@tanstack/react-query';
import { authApi } from '../axios';

export const useSwitchCompany = () => useMutation({
  mutationFn: (companyId) => authApi.post('/v1/auth/switch-company', { company_id: companyId }).then((r) => r.data),
});

export const useAddCompany = () => useMutation({
  mutationFn: (payload) => authApi.post('/v1/auth/add-company', payload).then((r) => r.data),
});
